import { OPENING_DELAY, OPENING_DURATION_VERTICAL } from './modal-gesture.constants';

export class ModalGestureDebounceUtil {
    #lastCallTime = 0;

    // Debounce while animations are running; may use state instead in future
    #debounceMs = OPENING_DELAY + OPENING_DURATION_VERTICAL;

    isDebounced(): boolean {
        const now = performance.now();
        const isWithinDebouncePeriod = now - this.#lastCallTime < this.#debounceMs;

        if (isWithinDebouncePeriod) {
            return false;
        }

        this.#lastCallTime = now;

        return true;
    }
}
